<template>
  <div id="app">
    <view-loader v-if="showViewLoader" margin-top-percentage="20"></view-loader>

    <manager-menu v-if="!showViewLoader"></manager-menu>

    <router-view v-if="!showViewLoader" />

    <manager-footer v-if="!showViewLoader"></manager-footer>
  </div>
</template>

<script>
import ManagerMenu from "@/components/Layout/ManagerMenu.vue";
import ManagerFooter from "@/components/Layout/ManagerFooter.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import Api from "@/api";

export default {
  components: {
    ManagerMenu,
    ManagerFooter,
    ViewLoader
  },

  data() {
    return {
      showViewLoader: true,
      templatLabels: null,
      loadingStartedAt: null,
      minLoadingMs: 2000
    };
  },

  mounted() {
    this.initApp(() => {
      var timeout = 0;
      var differenceInMs = window.performance.now() - this.loadingStartedAt;

      if (differenceInMs < this.minLoadingMs) {
        timeout = this.minLoadingMs - differenceInMs;
      }

      setTimeout(() => {
        this.showViewLoader = false;
      }, timeout);
    });
  },

  methods: {
    async initApp(finishCallback) {
      this.loadingStartedAt = window.performance.now();
      await this.loadTemplateLabels();
      await this.fetchAppConfigs();

      if (typeof finishCallback === "function") {
        finishCallback();
      }
    },

    loadTemplateLabels() {
      const endpoint = "/api/internal/v1/languages/1/translations";

      return Api()
        .get(endpoint)
        .then(response => {
          window.templateLabels = {};

          for (var i = 0; i < response.data.data.length; i++) {
            window.templateLabels[response.data.data[i].label] =
              response.data.data[i].text;
          }

          response.data.data;
        })
        .catch(() => {
          //
        });
    },

    fetchAppConfigs() {
      const endpoint =
        "api/internal/v1/partners/" +
        localStorage.partnerId +
        "/configs/manager-frontend";

      return Api()
        .get(endpoint)
        .then(response => {
          window.appConfigs = response.data.data;
        })
        .catch(() => {
          //
        });
    }
  }
};
</script>

<style>
@import "../public/css/venuzle.css";
</style>
